export default function Footer({showDevNotice}) {

    return (
      <footer className="mt-auto">

        

      </footer>
    );

}